import { registerTheme } from 'echarts/core'

export const ECHARTS_THEME_LIGHT = 'hydro-light' as const
export const ECHARTS_THEME_DARK = 'hydro-dark' as const

const TOOLBOX_ICON_LIGHT = '#333333'
const TOOLBOX_ICON_DARK = '#ffffff'

const LABEL_TEXT_LIGHT = '#4a4a4a'
const LABEL_TEXT_DARK = '#ffffff'

const LABEL_BACKGROUND_LIGHT = 'rgba(255, 255, 255, 1)'
const LABEL_BACKGROUND_DARK = 'rgba(15, 23, 42, 0.85)'

const axisThemeDark = {
    axisLine: { lineStyle: { color: '#666' } },
    axisLabel: { color: '#ccc' },
    splitLine: { lineStyle: { color: '#333' } },
}

const axisThemeLight = {
    axisLine: { lineStyle: { color: '#999' } },
    axisLabel: { color: '#333' },
    splitLine: { lineStyle: { color: '#eee' } },
}

const LIGHT_THEME_CONFIG = {
    backgroundColor: 'transparent',
    textStyle: {
        fontFamily: 'Roboto',
        color: '#5f6b7a',
    },
    title: {
        textStyle: {
            color: '#2f3a45',
        },
    },
    legend: {
        textStyle: {
            color: '#44505d',
            fontWeight: 500,
        },
    },
    tooltip: {
        backgroundColor: '#ffffff',
        borderColor: '#d0d7de',
        textStyle: { color: '#24292f' },
    },
    toolbox: {
        iconStyle: {
            color: TOOLBOX_ICON_LIGHT,
            borderColor: 'none',
        },
    },
    categoryAxis: axisThemeLight,
    valueAxis: axisThemeLight,
    timeAxis: axisThemeLight,
    logAxis: axisThemeLight,
}

const DARK_THEME_CONFIG = {
    backgroundColor: 'transparent',
    textStyle: {
        fontFamily: 'Roboto',
        color: '#b8c4d0',
    },
    title: {
        textStyle: {
            color: '#dce4ec',
        },
    },
    legend: {
        textStyle: {
            color: '#ffffff',
            fontWeight: 500,
        },
        inactiveColor: '#454545',
    },
    tooltip: {
        // backgroundColor: '#1e2a36',
        backgroundColor: '#2a2a2a',
        borderColor: '#3a4a5a',
        textStyle: { color: '#dce4ec' },
    },
    toolbox: {
        iconStyle: {
            color: TOOLBOX_ICON_DARK,
            borderColor: 'none',
        },
    },
    categoryAxis: axisThemeDark,
    valueAxis: axisThemeDark,
    timeAxis: axisThemeDark,
    logAxis: axisThemeDark,
}

let areThemesRegistered = false

export const registerEchartsThemes = (): void => {
    if (areThemesRegistered) {
        return
    }

    registerTheme(ECHARTS_THEME_LIGHT, LIGHT_THEME_CONFIG)
    registerTheme(ECHARTS_THEME_DARK, DARK_THEME_CONFIG)

    areThemesRegistered = true
}

export const getChartToolboxInactiveColor = (isDarkMode: boolean): string => isDarkMode ? TOOLBOX_ICON_DARK : TOOLBOX_ICON_LIGHT
export const getChartLabelColor = (isDarkMode: boolean): string => isDarkMode ? LABEL_TEXT_DARK : LABEL_TEXT_LIGHT
export const getChartLabelBackgroundColor = (isDarkMode: boolean): string => isDarkMode ? LABEL_BACKGROUND_DARK : LABEL_BACKGROUND_LIGHT